/* ==========================================================================
   MODERN PRODUCT SECTION SCRIPT
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Gallery Magnifier Lens Logic
  const viewport = document.getElementById('main-image-viewport');
  const lens = document.getElementById('magnifier-lens');
  const mainImage = document.getElementById('main-viewport-img');

  function updateMagnifierBackground() {
    if (lens && mainImage) {
      lens.style.backgroundImage = `url('${mainImage.src}')`;
    }
  }
  updateMagnifierBackground();

  if (viewport && lens && mainImage) {
    mainImage.addEventListener('mouseenter', () => {
      if (window.innerWidth <= 989) return;
      lens.style.display = 'block';
      updateMagnifierBackground();
    });

    mainImage.addEventListener('mouseleave', () => {
      lens.style.display = 'none';
    });

    mainImage.addEventListener('mousemove', (e) => {
      if (window.innerWidth <= 989) {
        lens.style.display = 'none';
        return;
      }
      
      const imgRect = mainImage.getBoundingClientRect();
      const containerRect = viewport.getBoundingClientRect();

      let x = e.clientX - imgRect.left;
      let y = e.clientY - imgRect.top;

      const lensWidth = lens.offsetWidth || 180;
      const lensHeight = lens.offsetHeight || 180;

      const minX = lensWidth / 2;
      const maxX = imgRect.width - lensWidth / 2;
      const minY = lensHeight / 2;
      const maxY = imgRect.height - lensHeight / 2;

      let clampedX = Math.min(Math.max(x, minX), maxX);
      let clampedY = Math.min(Math.max(y, minY), maxY);

      const imageLeftInContainer = imgRect.left - containerRect.left;
      const imageTopInContainer = imgRect.top - containerRect.top;

      const lensLeft = imageLeftInContainer + clampedX - lensWidth / 2;
      const lensTop = imageTopInContainer + clampedY - lensHeight / 2;

      lens.style.left = `${lensLeft}px`;
      lens.style.top = `${lensTop}px`;

      const zoom = 2.5;
      lens.style.backgroundSize = `${imgRect.width * zoom}px ${imgRect.height * zoom}px`;

      const bgX = x * zoom - lensWidth / 2;
      const bgY = y * zoom - lensHeight / 2;
      lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
    });
  }

  // 2. Thumbnail Switcher + Prev/Next Navigation (click-based, works on all devices)
  const thumbs = document.querySelectorAll('.thumb-box');
  const track = document.querySelector('.thumbnails-track-wrapper');
  const upBtn = document.getElementById('thumb-scroll-up');   // acts as "Previous"
  const downBtn = document.getElementById('thumb-scroll-down'); // acts as "Next"

  function setActiveThumb(thumb) {
    const newUrl = thumb.getAttribute('data-img-url');
    if (!newUrl || !mainImage) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = newUrl;
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    updateMagnifierBackground();
    thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  if (mainImage && thumbs.length > 0) {
    thumbs.forEach(thumb => {
      // Desktop hover preview still works
      thumb.addEventListener('mouseover', () => {
        if (window.innerWidth > 989) setActiveThumb(thumb);
      });
      // Click works on all devices (desktop + mobile/touch)
      thumb.addEventListener('click', () => setActiveThumb(thumb));
    });
  }

  function goToThumb(direction) {
    if (thumbs.length === 0) return;
    const thumbsArr = Array.from(thumbs);
    let currentIndex = thumbsArr.findIndex(t => t.classList.contains('active'));
    if (currentIndex === -1) currentIndex = 0;

    let newIndex = currentIndex + direction;
    if (newIndex < 0) newIndex = thumbsArr.length - 1; // wrap to last
    if (newIndex >= thumbsArr.length) newIndex = 0;    // wrap to first

    setActiveThumb(thumbsArr[newIndex]);
  }

  if (upBtn && downBtn && thumbs.length > 1) {
    upBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      goToThumb(-1); // Previous
    });

    downBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      goToThumb(1); // Next
    });
  }
  // 4. Quantity Stepper
  const qtyInput = document.querySelector('.quantity-stepper input[name="quantity"]');
  const qtyMinusBtn = document.querySelector('.quantity-stepper .minus');
  const qtyPlusBtn = document.querySelector('.quantity-stepper .plus');

  if (qtyInput && qtyMinusBtn && qtyPlusBtn) {
    qtyMinusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });

    qtyPlusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val < 99) qtyInput.value = val + 1;
    });
  }

  // 5. Variant Selection Listener (Dynamically updates hidden input ID so correct variant is added to cart)
  const variantRadios = document.querySelectorAll('.variant-radio-input');
  if (variantRadios.length > 0 && window.productVariants) {
    variantRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        const selected = {};
        document.querySelectorAll('.variant-radio-input:checked').forEach(r => {
          selected[r.getAttribute('data-option-position')] = r.value;
        });

        const matched = window.productVariants.find(v =>
          (!selected.option1 || v.option1 === selected.option1) &&
          (!selected.option2 || v.option2 === selected.option2) &&
          (!selected.option3 || v.option3 === selected.option3)
        );

        if (matched) {
          // --- FIX 1: UPDATE HIDDEN FORM VARIANT ID INPUT ---
          const hiddenVariantInput = document.querySelector('#product-form input[name="id"]');
          if (hiddenVariantInput) {
            hiddenVariantInput.value = matched.id;
          }

          // --- FIX 2: UPDATE WISHLIST BUTTON VARIANT ID ---
          const wishlistBtn = document.querySelector('.action-btn-wishlist');
          if (wishlistBtn) {
            wishlistBtn.setAttribute('data-variant-id', matched.id);
            if (matched.formatted_price) {
              wishlistBtn.setAttribute('data-price', matched.formatted_price);
            }
          }

          // --- FIX 3: UPDATE ADD TO CART & BUY NOW BUTTON AVAILABILITY ---
          const addToCartBtn = document.querySelector('#product-form .action-btn-primary');
          const buyNowBtnEl = document.querySelector('.action-btn-buy-now');

          if (addToCartBtn) {
            if (matched.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = addToCartBtn.getAttribute('data-original-text') || 'Add to Shopping Bag';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'Sold Out';
            }
          }

          if (buyNowBtnEl) {
            if (matched.available) {
              buyNowBtnEl.disabled = false;
              buyNowBtnEl.style.opacity = '1';
              buyNowBtnEl.style.cursor = 'pointer';
            } else {
              buyNowBtnEl.disabled = true;
              buyNowBtnEl.style.opacity = '0.5';
              buyNowBtnEl.style.cursor = 'not-allowed';
            }
          }

          // Update featured image
          if (matched.featured_image && mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.src = matched.featured_image.src;
            updateMagnifierBackground();
          }

          // Update main product price
          const mainPriceEl = document.getElementById('main-product-price');
          if (mainPriceEl && matched.formatted_price) {
            mainPriceEl.innerHTML = matched.formatted_price;
          }

          // Update High Demand inventory bar dynamically
          const badgeEl = document.getElementById('high-demand-badge');
          const progressBarEl = document.getElementById('high-demand-progress-bar');
          
          if (badgeEl && progressBarEl) {
            const optName = matched.option1 || matched.title;
            let qty = matched.inventory_quantity;

            if ((!qty || qty <= 0) && matched.available) {
              qty = (matched.id % 4) + 2; 
            }

            if (!matched.available) {
              badgeEl.textContent = 'Sold out';
              progressBarEl.style.width = '0%';
            } else {
              badgeEl.textContent = `Only ${qty} left for size ${optName}`;
              let pct = Math.min(100, Math.max(15, Math.round((qty / 10) * 100)));
              progressBarEl.style.width = pct + '%';
              progressBarEl.style.backgroundColor = '#7b1c3e';
            }
          }

          // Update URL query parameter variant ID
          if (history.replaceState) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', matched.id);
            window.history.replaceState({ path: newUrl.href }, '', newUrl.href);
          }
        }
      });
    });
  }

  // 6. Horizontal Product details / Fabric / Fit Tabs switcher
  const tabBtns = document.querySelectorAll('.tab-btn');
  const panels = document.querySelectorAll('.tab-panel');

  if (tabBtns.length > 0 && panels.length > 0) {
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        tabBtns.forEach(b => {
          b.classList.remove('active');
          b.style.color = '#666';
          b.style.borderBottomColor = 'transparent';
        });
        btn.classList.add('active');
        btn.style.color = '#7b1c3e';
        btn.style.borderBottomColor = '#7b1c3e';

        const tabName = btn.getAttribute('data-tab');
        panels.forEach(panel => {
          if (panel.id === `tab-${tabName}`) {
            panel.style.display = 'block';
          } else {
            panel.style.display = 'none';
          }
        });
      });
    });
  }

  // 7. Clean up empty headings or stray paragraph bullets in tab panels
  function cleanupTabPanels() {
    const tabPanels = document.querySelectorAll('.tab-panel');
    tabPanels.forEach(panel => {
      const elements = panel.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div, span, strong');
      elements.forEach(el => {
        if (!el.closest('ul') && !el.querySelector('img, svg, ul, table') && el.textContent.trim() === '') {
          el.remove();
        }
      });
    });
  }
  cleanupTabPanels();

  // 8. Buy It Now (Direct Checkout) Handler via /cart/add.js API
  const buyNowBtn = document.querySelector('.action-btn-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const form = document.getElementById('product-form');
      const variantInput = form ? form.querySelector('input[name="id"]') : null;
      const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      
      const variantId = variantInput ? variantInput.value : null;
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Processing...';

      if (!variantId) {
        window.location.href = '/checkout';
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: qty
          }]
        })
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(err => {
        console.warn('Direct cart add fallback:', err);
        if (form) {
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      });
    });
  }

  // 9. Interactive Wishlist Handler with LocalStorage & Toast Notification
  const wishlistBtns = document.querySelectorAll('.action-btn-wishlist');
  
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('theme_wishlist_items')) || [];
    } catch(e) {
      return [];
    }
  }

  function setWishlist(items) {
    try {
      localStorage.setItem('theme_wishlist_items', JSON.stringify(items));
    } catch(e) {}
  }

  function updateWishlistState(btn) {
    const handle = btn.getAttribute('data-handle') || btn.getAttribute('data-product-id');
    if (!handle) return;
    const wishlist = getWishlist();
    const isSaved = wishlist.some(item => item.handle === handle || item.id === handle);
    const svgPath = btn.querySelector('svg path');

    if (isSaved) {
      btn.classList.add('active-wishlist');
      if (svgPath) {
        svgPath.setAttribute('fill', '#7b1c3e');
        svgPath.setAttribute('stroke', '#7b1c3e');
      }
    } else {
      btn.classList.remove('active-wishlist');
      if (svgPath) {
        svgPath.setAttribute('fill', 'none');
        svgPath.setAttribute('stroke', 'currentColor');
      }
    }
  }

  wishlistBtns.forEach(btn => {
    updateWishlistState(btn);

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const handle = btn.getAttribute('data-handle') || btn.getAttribute('data-product-id');
      const title = btn.getAttribute('data-title') || 'Product';
      let wishlist = getWishlist();
      const existingIdx = wishlist.findIndex(item => item.handle === handle || item.id === handle);

      let msg = '';
      if (existingIdx > -1) {
        wishlist.splice(existingIdx, 1);
        msg = `Removed "${title}" from Wishlist`;
      } else {
        wishlist.push({
          handle: handle,
          id: btn.getAttribute('data-product-id'),
          variantId: btn.getAttribute('data-variant-id'),
          title: title,
          price: btn.getAttribute('data-price'),
          image: btn.getAttribute('data-image'),
          url: btn.getAttribute('data-url')
        });
        msg = `Added "${title}" to Wishlist`;
      }

      setWishlist(wishlist);
      updateWishlistState(btn);
      showWishlistToast(msg);
    });
  });

  function showWishlistToast(message) {
    let toast = document.getElementById('wishlist-toast-notice');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast-notice';
      toast.style.cssText = 'position: fixed; bottom: 30px; right: 30px; background: #7b1c3e; color: #ffffff; padding: 12px 24px; border-radius: 50px; font-family: Inter, sans-serif; font-size: 13px; font-weight: 600; box-shadow: 0 4px 15px rgba(0,0,0,0.2); z-index: 999999; transition: all 0.3s ease; opacity: 0; transform: translateY(20px); pointer-events: none;';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
    }, 3000);
  }
});

// Instagram Product Share Handler (Works like Facebook & Twitter sharing)
document.addEventListener('DOMContentLoaded', () => {
  const instaShareBtns = document.querySelectorAll('.instagram-share-btn');
  
  instaShareBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const shareUrl = btn.getAttribute('data-share-url') || window.location.href;
      const shareTitle = btn.getAttribute('data-share-title') || document.title;

      // 1. Mobile Web Share API (Opens Instagram app directly to post Story/Feed/DM)
      if (navigator.share) {
        navigator.share({
          title: shareTitle,
          url: shareUrl
        }).catch((err) => {
          if (err.name !== 'AbortError') {
            copyProductLink(shareUrl);
          }
        });
      } else {
        // 2. Desktop Fallback: Copy link to clipboard & open Instagram
        copyProductLink(shareUrl);
      }
    });
  });

  function copyProductLink(url) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(() => {
        alert('Product link copied to clipboard! Opening Instagram...');
        window.open('https://www.instagram.com', '_blank');
      }).catch(() => {
        fallbackCopy(url);
      });
    } else {
      fallbackCopy(url);
    }
  }

  function fallbackCopy(url) {
    const tempInput = document.createElement('input');
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    alert('Product link copied to clipboard! Opening Instagram...');
    window.open('https://www.instagram.com', '_blank');
  }
});